/**
 * Export data as CSV and trigger browser download.
 * @param {Object[]} rows - Array of objects to export
 * @param {Array<{key: string, label: string, format?: (v, row) => string}>} columns - Column definitions
 * @param {string} filename - Download filename (without .csv)
 */
export function exportToCSV(rows, columns, filename) {
  if (!rows.length) return

  const sep = ','
  const header = columns.map(c => `"${c.label}"`).join(sep)
  const lines = rows.map(row =>
    columns.map(col => {
      const val = col.format ? col.format(row[col.key], row) : row[col.key]
      const str = val == null ? '' : String(val)
      return `"${str.replace(/"/g, '""')}"`
    }).join(sep)
  )

  const bom = '\uFEFF' // UTF-8 BOM for Excel
  const csv = bom + [header, ...lines].join('\n')
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' })
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = `${filename}.csv`
  a.click()
  URL.revokeObjectURL(url)
}
